import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { FileUpload, FileUploadSelectEvent } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Image } from 'primereact/image';
import { Button } from "primereact/button";
import { StyleImageService } from "../../service/StyleImageService";
import { Link, useParams } from "react-router-dom";
import StyleImage from "../../models/StyleImage";
import SetupPrompt from "../../models/SetupPrompt";
import { StyleService } from "../../service/StyleService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { Chip } from "primereact/chip";
import StyleImagePrompt from "../../models/StyleImagePrompt";
import { Dialog } from "primereact/dialog";
import FloodFill from 'q-floodfill'
import StyleImageDescription from "../../models/StyleImageDescription";
import StyleImageList from "../../models/StyleImageList";
import { useMsal } from "@azure/msal-react";
import Style from "../../models/Style";

interface DrawingProps {
    frontImage: BlobPart | undefined;
    backImage: BlobPart | undefined;
    onSetStyleImageFront: (frontImage: BlobPart | undefined) => void;
    onSetStyleImageBack: (backImage: BlobPart | undefined) => void;
}

const StyleDrawing = (props: DrawingProps) => {
    let emptyStyle: Style = {
        styleCode: '',
        description: '',
        company: 0,
        garmentType: '',
        itemClass: '',
        materialGroup: '',
        materialGroupDescription: '',
        materialGroupDescription2: '',
        productCategory: '',
        productAllocation: 0,
        effectiveDate: '',
        hasBom: false,
        hasStripe: false,
        rowNumber: 0,
        productHierarchyOne: '',
        productHierarchyTwo: '',
        productHierarchyThree: '',
        uom: '',
        lastUpdateUserSap: '',
        lastUpdateSap: '',
        styleEffDate: '',
        styleMaterialGroup: '',
        styleMaterialType: '',
        styleStatus: '',
        styleLongDesc: '',
        styleCatCenYr: 0,
        styleCatPage: '',
        styleCatPict: '',
        styleCatBrand: '',
        styleWeight: 0,
        styleCompanyId: 0,
        styleLetprccd:''
    };

    let emptyStyleImage : StyleImage = {
        image_Id: 0,
        image_Type: '',
        image_Desc: '',
        image_Image: '',
        image_TimStp: '',
        image_Bkrd: undefined,
        image_UpdUser: '',
        image_UpDts: '',
        styleCode: ''
    }

    let emptyStyleImagePrompt : StyleImagePrompt = {
        imageClr_Id: 0,
        imageClr_ImageId: 0,
        description: '',
        imageType: '',
        imageClr_SetupPrompt: 0,
        imageClr_StrPrompt: '',
        imageClr_Seq: 0,
        imageClr_X1: 0,
        imageClr_Y1: 0,
        imageClr_X2: 0,
        imageClr_Y2: 0,
        imageClr_X3: 0,
        imageClr_Y3: 0,
        imageClr_X4: 0,
        imageClr_Y4: 0,
        imageClr_X5: 0,
        imageClr_Y5: 0,
        imageClr_X6: 0,
        imageClr_Y6: 0,
        imageClr_X7: 0,
        imageClr_Y7: 0,
        imageClr_X8: 0,
        imageClr_Y8: 0,
        imageClr_X9: 0,
        imageClr_Y9: 0,
        imageClr_Reverse: '',
        imageClr_RevPrompt: '',
        imageClr_UpdUser: '',
        imageClr_UpDts: ''
    }

    let emptyStyleImageDescription : StyleImageDescription = {
        description: ''
    }

    const [style, setStyle] = useState<Style>(emptyStyle);
    const [styleImageFrontId, setStyleImageFrontId] = useState<number>(0);
    const [styleImageBackId, setStyleImageBackId] = useState<number>(0);
    const [styleImageFront, setStyleImageFront] = useState<BlobPart>();
    const [styleImageBack, setStyleImageBack] = useState<BlobPart>();
    const [styleImage, setStyleImage] = useState<StyleImage>(emptyStyleImage);
    const [styleImageFrt, setStyleImageFrt] = useState<StyleImage>(emptyStyleImage);
    const [styleImageBck, setStyleImageBck] = useState<StyleImage>(emptyStyleImage);
    const [originalImageList, setOriginalImageList] = useState<StyleImageList[]>([]);
    const [imageList, setImageList] = useState<StyleImageList[]>([]);
    const [selectedImage, setSelectedImage] = useState<StyleImageDescription>(emptyStyleImageDescription);
    const [imageClicks, setImageClicks] = useState<number>(1);
    const [styleImageFrontDescription, setStyleImageFrontDescription] = useState<string>('No Front Image Found.');
    const [styleImageBackDescription, setStyleImageBackDescription] = useState<string>('No Back Image Found.');
    const [setupPrompts, setSetupPrompts] = useState<SetupPrompt[]>([]);
    const [loadingSetupPrompts, setLoadingSetupPrompts] = useState<boolean>(true);
    const [styleImagePrompts, setStyleImagePrompts] = useState<StyleImagePrompt[]>([]);
    const [styleImagePrompt, setStyleImagePrompt] = useState<StyleImagePrompt>(emptyStyleImagePrompt);
    const [loadingStyleImagePrompts, setLoadingStyleImagePrompts] = useState<boolean>(true);
    const [deleteAllOptionsDialog, setDeleteAllOptionsDialog] = useState(false);
    const [deletePromptDialog, setDeletePromptDialog] = useState(false);
    const [selectedSide, setSelectedSide] = useState<number | null>(null);
    const [newSelectedSide, setNewSelectedSide] = useState<number | null>(null);
    const [promptId, setPromptId] = useState<number>(0);
    const [setupPrompt, setSetupPrompt] = useState<number | null>(null);
    const [stripeSetupPrompt, setStripeSetupPrompt] = useState<string>('');
    const [sequence, setSequence] = useState<number | null>(null);
    const [isReverseStripe, setIsReverveStripe] = useState<boolean>(false);
    const [stripeReverePrompt, setStripeReversePrompt] = useState<string>('');
    const [promptX1, setPromptX1] = useState<number | null>(null);
    const [promptX2, setPromptX2] = useState<number | null>(null);
    const [promptX3, setPromptX3] = useState<number | null>(null);
    const [promptX4, setPromptX4] = useState<number | null>(null);
    const [promptX5, setPromptX5] = useState<number | null>(null);
    const [promptX6, setPromptX6] = useState<number | null>(null);
    const [promptX7, setPromptX7] = useState<number | null>(null);
    const [promptX8, setPromptX8] = useState<number | null>(null);
    const [promptX9, setPromptX9] = useState<number | null>(null);
    const [promptY1, setPromptY1] = useState<number | null>(null);
    const [promptY2, setPromptY2] = useState<number | null>(null);
    const [promptY3, setPromptY3] = useState<number | null>(null);
    const [promptY4, setPromptY4] = useState<number | null>(null);
    const [promptY5, setPromptY5] = useState<number | null>(null);
    const [promptY6, setPromptY6] = useState<number | null>(null);
    const [promptY7, setPromptY7] = useState<number | null>(null);
    const [promptY8, setPromptY8] = useState<number | null>(null);
    const [promptY9, setPromptY9] = useState<number | null>(null);
    const [lastUpdateUser, setLastUpdateUser] = useState<string>('');
    const [lastUpdateTime, setLastUpdateTime] = useState<string>('');
    const [canSave, setCanSave] = useState<boolean>(false);
    const [isEditing, setIsEditing] = useState(false);
    const toast = useRef<any>(null);
    const { styleCode } = useParams();
    const canvasFront = useRef<any>(null);
    const canvasBack = useRef<any>(null);
    const refImageFront = useRef<Image>(null);
    const refImageBack = useRef<Image>(null);
    const refBrowseImage = useRef<FileUpload>(null);
    const { accounts } = useMsal();

    useEffect(() => {
        if (!styleCode) { return; }
        
        StyleService.getStyle(styleCode).then(data => {
            setStyle(data);
        });

        StyleImageService.getStyleImages(styleCode).then((s: StyleImage[]) => {
            if (s.length > 0) {
                setStyleImageFrt(s[0]);
                setStyleImageBck(s[1]);
            }
        });

        StyleImageService.getImageList().then((data: StyleImageList[]) => {
            setOriginalImageList(data);
        });

        StyleService.getSetupPrompts(styleCode).then((data: SetupPrompt[]) => {
            if (!data) {
                setLoadingSetupPrompts(false);
                return;
            }
            setSetupPrompts(data);
            setLoadingSetupPrompts(false);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
            setLoadingSetupPrompts(false);
        });

        StyleImageService.getStyleImagePrompts(styleCode).then((data: StyleImagePrompt[]) => {
            if (!data) {
                setLoadingStyleImagePrompts(false);
                setStyleImagePrompts([]);
                return;
            }
            setStyleImagePrompts(data);
            setLoadingStyleImagePrompts(false);
        }).catch((e) => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
            setLoadingStyleImagePrompts(false);
        });
    }, [styleCode]);

    useEffect(() => {
        if (!styleCode) { return; }
        
        if (styleImageFrt.image_Image.toString().length > 8) {
            setStyleImageFrontId(styleImageFrt.image_Id);
            setStyleImageFront(styleImageFrt.image_Image);
            setStyleImageFrontDescription(styleImageFrt.image_Desc === '' ? '' : styleImageFrt.image_Desc);
        } else {
            setStyleImageFrontId(0);
            setStyleImageFront(undefined);
            setStyleImageFrontDescription('');
        }
    }, [styleImageFrt]);

    useEffect(() => {
        if (!styleCode) { return; }
        
        let canvasFrontContext = canvasFront.current.getContext("2d");
        
        if (styleImageFrt.image_Image.toString().length > 8) {
            canvasFrontContext.clearRect(0, 0, canvasFront.current.width, canvasFront.current.height);
            
            let imageWidth = refImageFront.current?.getImage().width ?? 0;
            let imageHeight = refImageFront.current?.getImage().height ?? 0;

            if (imageWidth === 0 || imageHeight === 0) {
                canvasFrontContext.clearRect(0, 0, canvasFront.current.width, canvasFront.current.height);
                canvasFrontContext.font = "14px Verdana";
                canvasFrontContext.fillStyle = "#fc2626";
                canvasFrontContext.fillText("No Front Image Found.", 5, 15);
            } else {
                let result = scaleImage(imageWidth, imageHeight, 300, 300, true);
                canvasFrontContext.drawImage(refImageFront.current?.getImage(), result.targetleft, result.targettop, result.width, result.height);
            }
        } else {
            canvasFrontContext.clearRect(0, 0, canvasFront.current.width, canvasFront.current.height);
            canvasFrontContext.font = "14px Verdana";
            canvasFrontContext.fillStyle = "#fc2626";
            canvasFrontContext.fillText("No Front Image Found.", 5, 15);  
        }
    }, [styleImageFront]);

    useEffect(() => {
        if (!styleCode) { return; }
        
        if (styleImageBck.image_Image.toString().length > 8) {
            setStyleImageBackId(styleImageBck.image_Id);
            setStyleImageBack(styleImageBck.image_Image);
            setStyleImageBackDescription(styleImageBck.image_Desc === '' ? '' : styleImageBck.image_Desc);
        } else {
            setStyleImageBackId(0);
            setStyleImageBack(undefined);
            setStyleImageBackDescription('');
        }
    }, [styleImageBck]);

    useEffect(() => {
        if (!styleCode) { return; }
        
        let canvasBackContext = canvasBack.current.getContext("2d");
        
        if (styleImageBck.image_Image.toString().length > 8) {
            canvasBackContext.clearRect(0, 0, canvasBack.current.width, canvasBack.current.height);
            
            let imageWidth = refImageBack.current?.getImage().width ?? 0;
            let imageHeight = refImageBack.current?.getImage().height ?? 0;

            if (imageWidth === 0 || imageHeight === 0) {
                canvasBackContext.clearRect(0, 0, canvasBack.current.width, canvasBack.current.height);
                canvasBackContext.font = "14px Verdana";
                canvasBackContext.fillStyle = "#fc2626";
                canvasBackContext.fillText("No Back Image Found.", 5, 15);
            } else {
                let result = scaleImage(imageWidth, imageHeight, 300, 300, true);
                canvasBackContext.drawImage(refImageBack.current?.getImage(), result.targetleft, result.targettop, result.width, result.height);
            }
        } else {
            canvasBackContext.clearRect(0, 0, canvasBack.current.width, canvasBack.current.height);
            canvasBackContext.font = "14px Verdana";
            canvasBackContext.fillStyle = "#fc2626";
            canvasBackContext.fillText("No Back Image Found.", 5, 15);  
        }
    }, [styleImageBack]);

    useEffect(() => {
        if (!styleCode) { return; }

        if (newSelectedSide !== null || selectedImage.description.length !== 0 || (styleImage.image_Id === 0 && styleImage.image_Image.toString().length > 8)) {
            setCanSave(true);
        } else {
            setCanSave(false);
        }
    }, [styleImage]);

    const setupPromptSeqTemplate = (rowData: SetupPrompt) => rowData.seq;
    const setupPromptTemplate = (rowData: SetupPrompt) => rowData.prompt;
    const imageColorIdTemplate = (rowData: StyleImagePrompt) => rowData.imageClr_Id;
    const descriptionTemplate = (rowData: StyleImagePrompt) => rowData.description;
    const imageTypeTemplate = (rowData: StyleImagePrompt) => rowData.imageType === 'FRT' ? 'FRONT' : 'BACK';
    const imageSetupPromptTemplate = (rowData: StyleImagePrompt) => rowData.imageClr_SetupPrompt;
    const stripeSetupPromptTemplate = (rowData: StyleImagePrompt) => rowData.imageClr_StrPrompt;
    const sequenceTemplate = (rowData: StyleImagePrompt) => rowData.imageClr_Seq;
    const x1Template = (rowData: StyleImagePrompt) => rowData.imageClr_X1;
    const y1Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y1;
    const x2Template = (rowData: StyleImagePrompt) => rowData.imageClr_X2;
    const y2Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y2;
    const x3Template = (rowData: StyleImagePrompt) => rowData.imageClr_X3;
    const y3Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y3;
    const x4Template = (rowData: StyleImagePrompt) => rowData.imageClr_X4;
    const y4Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y4;
    const x5Template = (rowData: StyleImagePrompt) => rowData.imageClr_X5;
    const y5Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y5;
    const x6Template = (rowData: StyleImagePrompt) => rowData.imageClr_X6;
    const y6Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y6;
    const x7Template = (rowData: StyleImagePrompt) => rowData.imageClr_X7;
    const y7Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y7;
    const x8Template = (rowData: StyleImagePrompt) => rowData.imageClr_X8;
    const y8Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y8;
    const x9Template = (rowData: StyleImagePrompt) => rowData.imageClr_X9;
    const y9Template = (rowData: StyleImagePrompt) => rowData.imageClr_Y9;
    const reverseStripeTemplate = (rowData: StyleImagePrompt) => rowData.imageClr_Reverse;
    const reversePromptTemplate = (rowData: StyleImagePrompt) => rowData.imageClr_RevPrompt;

    const editImageSetupPromptTemplate = (rowData: StyleImagePrompt) => {
        return (
            <>
                <Link className="pi pi-fw pi-pencil rowEdit" title="Edit" onClick={() => editImageSetupPrompt(rowData)} to={''}></Link>
            </>
        );
    };

    const deleteImageSetupPromptTemplate = (rowData: StyleImagePrompt) => {
        return (
            <>
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeletePrompt(rowData)} to={''}></Link>
            </>
        );
    };

    const saveImage = () => {
        if (!styleCode) { return; }
        
        let _styleImage = { ...styleImage };
        _styleImage.styleCode = styleCode;
        _styleImage.image_UpdUser = accounts[0].username.split('@')[0];
        _styleImage.image_UpDts = new Date().toISOString();

        if (_styleImage.image_Id === 0) {
            StyleImageService.addStyleImage(_styleImage).then((data: StyleImage) => {
                if (data) {
                    StyleImageService.getStyleImages(styleCode).then((s: StyleImage[]) => {
                        setStyleImageFrontId(s[0].image_Id);
                        setStyleImageFront(s[0].image_Image);
                        setStyleImageFrontDescription(s[0].image_Desc === '' ? '' : s[0].image_Desc);
                        setStyleImageBackId(s[1].image_Id);
                        setStyleImageBack(s[1].image_Image);
                        setStyleImageBackDescription(s[1].image_Desc === '' ? '' : s[1].image_Desc);
                        
                        if (_styleImage.image_Type === 'FRT') {
                            props.onSetStyleImageFront(_styleImage.image_Image);
                        } else {
                            props.onSetStyleImageBack(_styleImage.image_Image);
                        }
                        
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Image Saved', life: 3000 });
                    });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Save Image', life: 3000 });
                }
            });
        } else {
            StyleImageService.updateStyleImage(_styleImage).then((data: boolean) => {
                if (data) {
                    StyleImageService.getStyleImages(styleCode).then((s: StyleImage[]) => {
                        setStyleImageFrontId(s[0].image_Id);
                        setStyleImageFront(s[0].image_Image);
                        setStyleImageFrontDescription(s[0].image_Desc === '' ? '' : s[0].image_Desc);
                        setStyleImageBackId(s[1].image_Id);
                        setStyleImageBack(s[1].image_Image);
                        setStyleImageBackDescription(s[1].image_Desc === '' ? '' : s[1].image_Desc);
                        
                        if (_styleImage.image_Type === 'FRT') {
                            props.onSetStyleImageFront(_styleImage.image_Image);
                        } else {
                            props.onSetStyleImageBack(_styleImage.image_Image);
                        }
                        
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Image Updated', life: 3000 });
                    });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Image', life: 3000 });
                }
            });
        }
    }

    const savePrompt = () => {
        if (!styleCode) { return; }

        let _styleImagePrompt = { ...styleImagePrompt };

        _styleImagePrompt.imageClr_Id = promptId;
        _styleImagePrompt.imageClr_ImageId = selectedSide === 0 ? styleImageFrontId : styleImageBackId;
        _styleImagePrompt.description = selectedSide === 0 ? styleImageFrontDescription : styleImageBackDescription;
        _styleImagePrompt.imageType = selectedSide === 0 ? "FRT" : "BCK";
        _styleImagePrompt.imageClr_SetupPrompt = setupPrompt;
        _styleImagePrompt.imageClr_StrPrompt = stripeSetupPrompt;
        _styleImagePrompt.imageClr_Seq = sequence;
        _styleImagePrompt.imageClr_X1 = promptX1 ?? 0;
        _styleImagePrompt.imageClr_Y1 = promptY1 ?? 0;
        _styleImagePrompt.imageClr_X2 = promptX2 ?? 0;
        _styleImagePrompt.imageClr_X2 = promptX2 ?? 0;
        _styleImagePrompt.imageClr_Y2 = promptY2 ?? 0;
        _styleImagePrompt.imageClr_X3 = promptX3 ?? 0;
        _styleImagePrompt.imageClr_Y3 = promptY3 ?? 0;
        _styleImagePrompt.imageClr_X4 = promptX4 ?? 0;
        _styleImagePrompt.imageClr_Y4 = promptY4 ?? 0;
        _styleImagePrompt.imageClr_X5 = promptX5 ?? 0;
        _styleImagePrompt.imageClr_Y5 = promptY5 ?? 0;
        _styleImagePrompt.imageClr_X6 = promptX6 ?? 0;
        _styleImagePrompt.imageClr_Y6 = promptY6 ?? 0;
        _styleImagePrompt.imageClr_X7 = promptX7 ?? 0;
        _styleImagePrompt.imageClr_Y7 = promptY7 ?? 0;
        _styleImagePrompt.imageClr_X8 = promptX8 ?? 0;
        _styleImagePrompt.imageClr_Y8 = promptY8 ?? 0;
        _styleImagePrompt.imageClr_X9 = promptX9 ?? 0;
        _styleImagePrompt.imageClr_Y9 = promptY9 ?? 0;
        _styleImagePrompt.imageClr_Reverse = isReverseStripe ? 'Y' : 'N';
        _styleImagePrompt.imageClr_RevPrompt = stripeReverePrompt;
        _styleImagePrompt.imageClr_UpdUser = accounts[0].username.split('@')[0];
        _styleImagePrompt.imageClr_UpDts = new Date().toISOString();

        if (!isEditing) {
            StyleImageService.addStyleImagePrompt(_styleImagePrompt).then((data: StyleImagePrompt) => {
                if (data) {
                    StyleImageService.getStyleImagePrompts(styleCode).then((data: StyleImagePrompt[]) => {
                        if (!data) {
                            setLoadingStyleImagePrompts(false);
                            setStyleImagePrompts([]);
                            return;
                        }
                        setStyleImagePrompts(data);
                        setLoadingStyleImagePrompts(false);
                        resetImageDrawing();
                    }).catch((e) => {
                        toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
                        setLoadingStyleImagePrompts(false);
                    });
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Image Prompt Saved', life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Save Image Prompt', life: 3000 });
                }
            });
        } else {
            StyleImageService.updateStyleImagePrompt(_styleImagePrompt).then((data: boolean) => {
                if (data) {
                    StyleImageService.getStyleImagePrompts(styleCode).then((data: StyleImagePrompt[]) => {
                        if (!data) {
                            setLoadingStyleImagePrompts(false);
                            setStyleImagePrompts([]);
                            return;
                        }
                        setStyleImagePrompts(data);
                        setLoadingStyleImagePrompts(false);
                        resetImageDrawing();
                    }).catch((e) => {
                        toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
                        setLoadingStyleImagePrompts(false);
                    });
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Image Prompt Updated', life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Image Prompt', life: 3000 });
                }
            });
        };
    }

    const chooseOptions = { icon: 'pi pi-fw pi-image', iconOnly: false, className: 'p-button-outlined p-button p-button-sm', label: 'Browse'};

    const formatDate = (strDate: string | null) => {
        const date = strDate ? new Date(strDate) : null;
        const formattedDate = date ? `${date.toLocaleDateString()} ${date.toLocaleTimeString()}` : 'N/A';
        return formattedDate;
    }

    const clearFrontImage = () => {
        if (!styleCode) { return; }
        
        StyleImageService.clearFrontImage(styleCode).then((data) => {
            if (data) {
                setStyleImageFrontId(0);
                setStyleImageFront(undefined);
                setStyleImageFrontDescription('');
                loadCanvasFront();
                props.onSetStyleImageFront(undefined);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Front Image Cleared', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Front Image Clear Failed', life: 3000 });
            }
        });
    }

    const clearBackImage = () => {
        if (!styleCode) { return; }

        StyleImageService.clearBackImage(styleCode).then((data) => {
            if (data) {
                setStyleImageBackId(0);
                setStyleImageBack(undefined);
                setStyleImageBackDescription('');
                loadCanvasBack();
                props.onSetStyleImageBack(undefined);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Back Image Cleared', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Back Image Clear Failed', life: 3000 });
            }
        });
    }

    const deleteAllOptions = () => {
        if (!styleCode) { return; }
        
        StyleImageService.deleteAllOptions(styleImageFrontId, styleImageBackId).then((data) => {
            if (data) {
                StyleImageService.getStyleImagePrompts(styleCode).then((data: StyleImagePrompt[]) => {
                    if (!data) {
                        setLoadingStyleImagePrompts(false);
                        setStyleImagePrompts([]);
                        return;
                    }
                    setStyleImagePrompts(data);
                    setLoadingStyleImagePrompts(false);
                }).catch((e) => {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
                    setLoadingStyleImagePrompts(false);
                });

                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'All Color Options Deleted', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Delete All Color Options', life: 3000 });
            }
        });

        setDeleteAllOptionsDialog(false);
    }

    const hideDeleteAllOptionsDialog = () => {
        setDeleteAllOptionsDialog(false);
    };

    const deleteAllOptionsDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteAllOptionsDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteAllOptions} />
        </>
    );

    const deletePrompt = () => {
        if (!styleCode) { return; }

        StyleImageService.deleteStyleImagePrompt(styleImagePrompt).then((data) => {
            if (data) {
                StyleImageService.getStyleImagePrompts(styleCode).then((data: StyleImagePrompt[]) => {
                    if (!data) {
                        setLoadingStyleImagePrompts(false);
                        setStyleImagePrompts([]);
                        return;
                    }
                    setStyleImagePrompts(data);
                    setLoadingStyleImagePrompts(false);
                    resetImageDrawing();
                }).catch((e) => {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Error in DB', life: 3000 });
                    setLoadingStyleImagePrompts(false);
                });
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Image Prompt Deleted', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Delete Image Prompt', life: 3000 });
            }
        });

        setDeletePromptDialog(false);
    }

    const confirmDeletePrompt = (rowData: StyleImagePrompt) => {
        setStyleImagePrompt(rowData);
        setDeletePromptDialog(true);
    }

    const hideDeletePromptDialog = () => {
        setDeletePromptDialog(false);
    };

    const deletePromptDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeletePromptDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deletePrompt} />
        </>
    );

    const editImageSetupPrompt = (rowData: StyleImagePrompt) => {
        setStyleImagePrompt(rowData);
        setPromptId(rowData.imageClr_Id);
        setSelectedSide(rowData.imageType === 'FRT' ? 0 : 1);
        setSetupPrompt(rowData.imageClr_SetupPrompt);
        setStripeSetupPrompt(rowData.imageClr_StrPrompt);
        setSequence(rowData.imageClr_Seq);
        setPromptX1(rowData.imageClr_X1);
        setPromptY1(rowData.imageClr_Y1);
        setPromptX2(rowData.imageClr_X2);
        setPromptY2(rowData.imageClr_Y2);
        setPromptX3(rowData.imageClr_X3);
        setPromptY3(rowData.imageClr_Y3);
        setPromptX4(rowData.imageClr_X4);
        setPromptY4(rowData.imageClr_Y4);
        setPromptX5(rowData.imageClr_X5);
        setPromptY5(rowData.imageClr_Y5);
        setPromptX6(rowData.imageClr_X6);
        setPromptY6(rowData.imageClr_Y6);
        setPromptX7(rowData.imageClr_X7);
        setPromptY7(rowData.imageClr_Y7);
        setPromptX8(rowData.imageClr_X8);
        setPromptY8(rowData.imageClr_Y8);
        setPromptX9(rowData.imageClr_X9);
        setPromptY9(rowData.imageClr_Y9);
        setIsReverveStripe(rowData.imageClr_Reverse === 'Y' ? true : false);
        setStripeReversePrompt(rowData.imageClr_RevPrompt);
        setLastUpdateUser(rowData.imageClr_UpdUser);
        setLastUpdateTime(rowData.imageClr_UpDts);
        setIsEditing(true);
    };

    const resetDrawingPrompt = () => {
        setSelectedSide(null);
        setLastUpdateUser('');
        setLastUpdateTime('');
        setSetupPrompt(null);
        setStripeSetupPrompt('');
        setSequence(null);
        setPromptX1(null);
        setPromptY1(null);
        setPromptX2(null);
        setPromptY2(null);
        setPromptX3(null);
        setPromptY3(null);
        setPromptX4(null);
        setPromptY4(null);
        setPromptX5(null);
        setPromptY5(null);
        setPromptX6(null);
        setPromptY6(null);
        setPromptX7(null);
        setPromptY7(null);
        setPromptX8(null);
        setPromptY8(null);
        setPromptX9(null);
        setPromptY9(null);
        setIsReverveStripe(false);
        setStripeReversePrompt('');
        setImageClicks(1);
        setStyleImagePrompt(emptyStyleImagePrompt);
        setIsEditing(false);
    }

    const scaleImage = (srcwidth: number, srcheight: number, targetwidth: number, targetheight: number, fLetterBox: boolean) => {
        let result = { width: 0, height: 0, targetwidth: 0, targetheight: 0, fScaleToTargetWidth: true, targetleft: 0, targettop: 0 };
    
        if ((srcwidth <= 0) || (srcheight <= 0) || (targetwidth <= 0) || (targetheight <= 0)) {
            return result;
        }
    
        // scale to the target width
        let scaleX1 = targetwidth;
        let scaleY1 = (srcheight * targetwidth) / srcwidth;
    
        // scale to the target height
        let scaleX2 = (srcwidth * targetheight) / srcheight;
        let scaleY2 = targetheight;
    
        // now figure out which one we should use
        let fScaleOnWidth = (scaleX2 > targetwidth);

        if (fScaleOnWidth) {
            fScaleOnWidth = fLetterBox;
        } else {
            fScaleOnWidth = !fLetterBox;
        }
    
        if (fScaleOnWidth) {
            result.width = Math.floor(scaleX1);
            result.height = Math.floor(scaleY1);
            result.fScaleToTargetWidth = true;
        } else {
            result.width = Math.floor(scaleX2);
            result.height = Math.floor(scaleY2);
            result.fScaleToTargetWidth = false;
        }

        result.targetleft = Math.floor((targetwidth - result.width) / 2);
        result.targettop = Math.floor((targetheight - result.height) / 2);
    
        return result;
    }

    const loadCanvasFront = () => {
        let canvasFrontContext = canvasFront.current.getContext("2d");
        let _styleImageFrt = { ...styleImageFrt };

        if (_styleImageFrt.image_Image.toString().length > 8) {
            canvasFrontContext.clearRect(0, 0, canvasFront.current.width, canvasFront.current.height);
            let imageWidth = refImageFront.current?.getImage().width ?? 0;
            let imageHeight = refImageFront.current?.getImage().height ?? 0;

            if (imageWidth === 0 || imageHeight === 0) {
                canvasFrontContext.clearRect(0, 0, canvasFront.current.width, canvasFront.current.height);
                canvasFrontContext.font = "14px Verdana";
                canvasFrontContext.fillStyle = "#fc2626";
                canvasFrontContext.fillText("No Front Image Found.", 5, 15);
            } else {
                let result = scaleImage(imageWidth, imageHeight, 300, 300, true);
                canvasFrontContext.drawImage(refImageFront.current?.getImage(), result.targetleft, result.targettop, result.width, result.height);
            }
        } else {
            canvasFrontContext.clearRect(0, 0, canvasFront.current.width, canvasFront.current.height);
            canvasFrontContext.font = "14px Verdana";
            canvasFrontContext.fillStyle = "#fc2626";
            canvasFrontContext.fillText("No Front Image Found.", 5, 15);
        }
    }

    const loadCanvasBack = () => {
        let canvasBackContext = canvasBack.current.getContext("2d");
        let _styleImageBck = { ...styleImageBck };

        if (_styleImageBck.image_Image.toString().length > 8) {
            canvasBackContext.clearRect(0, 0, canvasBack.current.width, canvasBack.current.height);
            let imageWidth = refImageBack.current?.getImage().width ?? 0;
            let imageHeight = refImageBack.current?.getImage().height ?? 0;
            
            if (imageWidth === 0 || imageHeight === 0) {
                canvasBackContext.clearRect(0, 0, canvasBack.current.width, canvasBack.current.height);
                canvasBackContext.font = "14px Verdana";
                canvasBackContext.fillStyle = "#fc2626";
                canvasBackContext.fillText("No Back Image Found.", 5, 15);
            } else {
                let result = scaleImage(imageWidth, imageHeight, 300, 300, true);
                canvasBackContext.drawImage(refImageBack.current?.getImage(), result.targetleft, result.targettop, result.width, result.height);
            }            
        } else {
            canvasBackContext.clearRect(0, 0, canvasBack.current.width, canvasBack.current.height);
            canvasBackContext.font = "14px Verdana";
            canvasBackContext.fillStyle = "#fc2626";
            canvasBackContext.fillText("No Back Image Found.", 5, 15);
        }
    }

    const resetImageDrawing = () => {
        if (!styleCode) { return; }

        StyleImageService.getStyleImages(styleCode).then((s: StyleImage[]) => {
            if (s.length > 0) {
                setStyleImageFront(s[0].image_Image);
                props.onSetStyleImageFront(s[0].image_Image);
                setStyleImageBack(s[1].image_Image);
                props.onSetStyleImageBack(s[1].image_Image);
                
                loadCanvasFront();
                loadCanvasBack();
            } else {
                setStyleImageFront(undefined);
                setStyleImageBack(undefined);
            }
        });
        
        setNewSelectedSide(null);
        setStyleImage(emptyStyleImage);
        setSelectedImage(emptyStyleImageDescription);

        if (refBrowseImage.current && refBrowseImage.current.props.chooseOptions) {
            refBrowseImage.current.clear();
        }
    }

    const setXYPrompts = (imageClicks: number, x: number, y: number) => {
        switch(imageClicks) {
            case 1:
                setPromptX1(Math.round(x));
                setPromptY1(Math.round(y));
                break;
            case 2:
                setPromptX2(Math.round(x));
                setPromptY2(Math.round(y));
                break;
            case 3:
                setPromptX3(Math.round(x));
                setPromptY3(Math.round(y));
                break;
            case 4:
                setPromptX4(Math.round(x));
                setPromptY4(Math.round(y));
                break;
            case 5:
                setPromptX5(Math.round(x));
                setPromptY5(Math.round(y));
                break;
            case 6:
                setPromptX6(Math.round(x));
                setPromptY6(Math.round(y));
                break;
            case 7:
                setPromptX7(Math.round(x));
                setPromptY7(Math.round(y));
                break;
            case 8:
                setPromptX8(Math.round(x));
                setPromptY8(Math.round(y));
                break;
            case 9:
                setPromptX9(Math.round(x));
                setPromptY9(Math.round(y));
                break;
        }
    }

    const onChangeSelectedSide = (e: RadioButtonChangeEvent) => {
        setNewSelectedSide(e.value);

        let _originalImageList = [...originalImageList];
        let _filteredImageList = _originalImageList.filter((item) => e.value === 0 ? item.imageType === 'FRT' : item.imageType === 'BCK');
        setImageList(_filteredImageList);
    }

    const onClickCanvasFront = (e: any) => {
        if (!isEditing && styleImageFrontId !== 0) {
            let rect = e.target.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            
            let ctx = canvasFront.current.getContext("2d");
            const imgData = ctx.getImageData(0, 0, canvasFront.current.width, canvasFront.current.height);
            const floodFill = new FloodFill(imgData);
            floodFill.fill('#0000FF', Math.round(x), Math.round(y), 0);
            ctx.putImageData(floodFill.imageData, 0, 0);

            if (imageClicks <= 9) {
                setImageClicks(imageClicks + 1);
                setXYPrompts(imageClicks, x, y);
            }

            setSelectedSide(0);
        }
    }

    const onClickCanvasBack = (e: any) => {
        if (!isEditing && styleImageBackId !== 0) {
            let rect = e.target.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            
            let ctx = canvasBack.current.getContext("2d");
            const imgData = ctx.getImageData(0, 0, canvasBack.current.width, canvasBack.current.height);
            const floodFill = new FloodFill(imgData);
            floodFill.fill('#0000FF', Math.round(x), Math.round(y), 0);
            ctx.putImageData(floodFill.imageData, 0, 0);
    
            if (imageClicks <= 9) {
                setImageClicks(imageClicks + 1);
                setXYPrompts(imageClicks, x, y);
            }
            
            setSelectedSide(1);
        }
    }

    const onSelectImage = (e: DropdownChangeEvent) => {
        if (newSelectedSide === null) { return; }

        let _styleImageDescription = { ...selectedImage };
        _styleImageDescription.description = e.target.value;

        setSelectedImage(_styleImageDescription);

        StyleImageService.getStyleImageByDescription(_styleImageDescription).then((data: StyleImage) => {
            if (data.image_Type === 'FRT') {
                setStyleImage(data);
                setStyleImageFrt(data);
                setStyleImageFront(data.image_Image);
            } else {
                setStyleImage(data);
                setStyleImageBck(data);
                setStyleImageBack(data.image_Image);
            }
        });
    }

    const handleFileSelect = (event: FileUploadSelectEvent) => {
        if (newSelectedSide === null) { return; }
        
        setSelectedImage(emptyStyleImageDescription);

        const files = event.files;
        var newFiles: File[] = [];

        for (let i = 0; i < files.length; i++) {
            if (["image/jpeg", "image/png", "image/gif"].includes(files[i].type)) {
                newFiles.push(files[i]);
            }
        }

        if (newFiles.length > 0) {
            const reader = new FileReader();
            let _newStyleImage = { ...styleImage };

            reader.onload = (e: ProgressEvent<FileReader>) => {
                if (e.target?.result) {
                    var base64result = (e.target?.result as string).replace(/^data:image\/\w+;base64,/, "");
                    if (newSelectedSide === 0) {
                        setStyleImageFront(base64result);

                        _newStyleImage.image_Type = 'FRT';
                        _newStyleImage.image_Desc = newFiles[0].name;
                        _newStyleImage.image_Image = base64result;
                        _newStyleImage.image_TimStp = new Date(newFiles[0].lastModified).toISOString();
                        setStyleImageFrontDescription(newFiles[0].name);
                    } else {
                        setStyleImageBack(base64result);

                        _newStyleImage.image_Type = 'BCK';
                        _newStyleImage.image_Desc = newFiles[0].name;
                        _newStyleImage.image_Image = base64result;
                        _newStyleImage.image_TimStp = new Date(newFiles[0].lastModified).toISOString();
                        setStyleImageBackDescription(newFiles[0].name);
                    }

                    setStyleImage(_newStyleImage);
                }
            };

            reader.readAsDataURL(newFiles[0]);
        } else {
            if (newSelectedSide === 0) {
                setStyleImageFront(undefined);
            } else {
                setStyleImageBack(undefined);
            }
        }
    };

    return (
        <div className="grid-nogutter">
            <Toast ref={toast} />

            <div className="col-12">
                <div className="grid">
                    <div className="col-6 md:col-4">
                        <div className="p-fluid">
                            <h5>Image Drawing</h5>
                            <div className="grid-nogutter col-6">
                                <div className="flex flex-wrap gap-3">
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="newFront" name="newLocation" value={0} checked={newSelectedSide === 0} disabled={style.garmentType !== 'U'} onChange={onChangeSelectedSide} />
                                        <label htmlFor="newFront" className="ml-2">Front</label>
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="newBack" name="newLocation" value={1} checked={newSelectedSide === 1} disabled={style.garmentType !== 'U'} onChange={onChangeSelectedSide} />
                                        <label htmlFor="newBack" className="ml-2">Back</label>
                                    </div>
                                </div>
                            </div>
                            <div className="grid-nogutter col-6">
                                <div className="col-12 md:col-6">
                                    <label htmlFor="imageList" className={classNames('font-bold text-xs')}>Pick Image</label>
                                    <Dropdown inputId="imageList" value={selectedImage.description} options={imageList} optionLabel="description" optionValue="description" className={classNames('w-15rem mt-2')} disabled={newSelectedSide === null} onChange={onSelectImage} filter placeholder="Select Image" virtualScrollerOptions={{ itemSize: 50 }} />
                                </div>
                            </div>
                         </div>

                         <div className="grid col-12">
                            <div className="col-12">
                                <div className="flex align-content-start flex-wrap">
                                    <FileUpload ref={refBrowseImage} mode="basic" url="/Windows" accept="image/*" maxFileSize={1000000} chooseOptions={chooseOptions} className="mr-3" disabled={newSelectedSide === null} onSelect={handleFileSelect} />
                                    <Button icon="pi pi-save" size="small" outlined severity="success" label="Save" type="submit" className="mr-3" disabled={!canSave} onClick={saveImage} />
                                    <Button icon="pi pi-times" size="small" outlined severity="danger" label="Cancel" type="button" disabled={style.garmentType !== 'U'} onClick={resetImageDrawing}/>
                                </div>
                            </div>
                        </div>

                        <div className="grid col-12">
                            <div className="col-12">
                                <DataTable value={setupPrompts} dataKey="seq" size="small" loading={loadingSetupPrompts}
                                    scrollable scrollHeight="200px"
                                    emptyMessage="No current sequences found.">
                                    <Column field="seq" header="Seq"  body={setupPromptSeqTemplate} align="center" alignHeader="center" ></Column>
                                    <Column field="prompt" header="Prompt"  body={setupPromptTemplate} align="center" alignHeader="center" ></Column>
                                </DataTable>
                            </div>
                        </div>                                
                    </div>

                    <div className="col-6 md:col-3">
                        <div className="p-fluid">
                            <h6>Front Image</h6>
                            <div className="grid col-12">
                                <div className="col-12 md:col-12">
                                    <div className="col-12 md:col-12">
                                        {
                                            <canvas ref={canvasFront} style={{margin: "0px", paddingInline:"0px", borderInline: "0px", overflowInline: "hidden", backgroundColor: "white"}} width={300} height={300} onClick={onClickCanvasFront}>
                                                <Image ref={refImageFront} className="hidden" src={`data:image/png;base64,${styleImageFront}`} alt="No image found." />
                                            </canvas>
                                        }
                                        {
                                            styleImageFrontId !== 0  && 
                                                <>
                                                    <div className="grid p-fluid">
                                                        <div className="col-12 md:col-9"><InputText disabled placeholder={styleImageFrontDescription} /></div>
                                                        <div className="col-12 md:col-1 mt-3"><Link className="pi pi-fw pi-trash trashIcon" title="Remove" to={''} onClick={clearFrontImage}></Link></div>
                                                    </div>                                            
                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-6 md:col-5">
                        <div className="p-fluid">
                            <h6>Back Image</h6>
                            <div className="grid col-12">
                                <div className="col-12 md:col-5">
                                    <div className="col-12 md:col-12">
                                        {
                                            <canvas ref={canvasBack} style={{margin: "0px", paddingInline:"0px", borderInline: "0px", overflowInline: "hidden", backgroundColor: "white"}} width={300} height={300} onClick={onClickCanvasBack}>
                                                <Image ref={refImageBack} className="hidden" src={`data:image/png;base64,${styleImageBack}`} alt="No image found." />
                                            </canvas>
                                        }
                                        {
                                            styleImageBackId !== 0 &&
                                            <>
                                                <div className="grid p-fluid">
                                                    <div className="col-12 md:col-9"><InputText disabled placeholder={styleImageBackDescription} /></div>
                                                    <div className="col-12 md:col-1 mt-3"><Link className="pi pi-fw pi-trash trashIcon" title="Remove" to={''} onClick={clearBackImage}></Link></div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid" style={style.garmentType !== 'U' ? { display: 'none'} : {display: 'block'}}>
                    <Card className="border-gray-500 border-1" >
                        <div className="grid p-fluid">
                            <div className="col-12 md:col-1">
                                <Button icon="pi pi-save" size="small" outlined severity="success" label="Save" type="submit" 
                                    disabled={
                                        (setupPrompt === null && stripeSetupPrompt === '' && sequence === null) || 
                                        (setupPrompt !== null && stripeSetupPrompt === '' && sequence === null) ||
                                        (setupPrompt === null && stripeSetupPrompt !== '' && sequence === null) ||
                                        (style.garmentType !== 'U')
                                    } 
                                    onClick={savePrompt} />
                            </div>
                            <div className="col-12 md:col-1">
                                <Button icon="pi pi-times" size="small" outlined severity="danger" label="Cancel" type="button" disabled={style.garmentType !== 'U'} onClick={resetDrawingPrompt} />
                            </div>
                            <div className="col-12 md:col-1 w-13rem">
                                <Button icon="pi pi-trash" size="small" outlined severity="danger" label="Delete All Options" type="button" disabled={style.garmentType !== 'U'} onClick={() => {setDeleteAllOptionsDialog(true)}} />
                            </div>
                            <div className="col-12 md:col-2 mt-2">
                                <div className="flex flex-wrap gap-3">
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="front" name="location" value={0} checked={selectedSide === 0} disabled={isEditing || style.garmentType !== 'U'} onChange={(e: RadioButtonChangeEvent) => {setSelectedSide(e.value); }} />
                                        <label htmlFor="front" className="ml-2">Front</label>
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="back" name="location" value={1} checked={selectedSide === 1} disabled={isEditing || style.garmentType !== 'U'} onChange={(e: RadioButtonChangeEvent) => {setSelectedSide(e.value); }} />
                                        <label htmlFor="back" className="ml-2">Back</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 md:col-5">
                                <Chip style={{ fontWeight: 'bold' }} label={`Last Update: ${lastUpdateUser.trim().length > 0 ? lastUpdateUser + ' on ' : ''} ${formatDate(lastUpdateTime)}`} icon="pi pi-sync" />
                            </div>
                        </div>

                        <div className="grid p-fluid">
                            <div className="col-12 md:col-1 w-10rem">
                                <label htmlFor="setupPrompt" className="font-bold text-xs">Setup Prompt</label>
                                <InputNumber id="setupPrompt" value={setupPrompt} disabled={stripeSetupPrompt !== '' || isEditing || style.garmentType !== 'U'} inputClassName="mt-2" onChange={(e) => setSetupPrompt(e.value)} />
                            </div>
                            <div className="col-12 md:col-1 w-10rem">
                                <label htmlFor="stripeSetupPrompt" className="font-bold text-xs">Stripe Setup Prompt</label>
                                <InputText id="stripeSetupPrompt" value={stripeSetupPrompt} disabled={setupPrompt !== null || isEditing || style.garmentType !== 'U'} className="mt-2" onChange={(e) => setStripeSetupPrompt(e.target.value)} />
                            </div>
                            <div className="col-12 md:col-1 w-10rem">
                                <label htmlFor="sequence" className="font-bold text-xs">Sequence</label>
                                <InputNumber id="sequence" value={sequence} disabled={isEditing || style.garmentType !== 'U'} inputClassName="mt-2" onChange={(e) => setSequence(e.value)} />
                            </div>
                            <div className="col-12 md:col-1 w-11rem">
                                <Checkbox inputId="isReverseStripe" className="mt-5" checked={isReverseStripe} disabled={style.garmentType !== 'U'} onChange={(e) => setIsReverveStripe(e.checked ? true : false)} />
                                <label htmlFor="isReverseStripe" className="ml-2">Reverse Stripe</label>
                            </div>
                            <div className="col-12 md:col-1 w-10rem">
                                <label htmlFor="reversePrompt" className="font-bold text-xs">Reverse Prompt</label>
                                <InputText id="reversePrompt" value={stripeReverePrompt} disabled={!isReverseStripe || style.garmentType !== 'U'} className="mt-2" onChange={(e) => setStripeReversePrompt(e.target.value)} />
                            </div>
                        </div>

                        <div className="grid p-fluid">
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX1" className="font-bold text-xs">X1</label>
                                <InputNumber id="promptX1" value={promptX1} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX1(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX2" className="font-bold text-xs">X2</label>
                                <InputNumber id="promptX2" value={promptX2} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX2(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX3" className="font-bold text-xs">X3</label>
                                <InputNumber id="promptX3" value={promptX3} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX3(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX4" className="font-bold text-xs">X4</label>
                                <InputNumber id="promptX4" value={promptX4} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX4(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX5" className="font-bold text-xs">X5</label>
                                <InputNumber id="promptX5" value={promptX5} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX5(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX6" className="font-bold text-xs">X6</label>
                                <InputNumber id="promptX6" value={promptX6} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX6(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX7" className="font-bold text-xs">X7</label>
                                <InputNumber id="promptX7" value={promptX7} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX7(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX8" className="font-bold text-xs">X8</label>
                                <InputNumber id="promptX8" value={promptX8} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX8(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptX9" className="font-bold text-xs">X9</label>
                                <InputNumber id="promptX9" value={promptX9} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptX9(e.value)} />
                            </div>
                        </div>

                        <div className="grid p-fluid">
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY1" className="font-bold text-xs">Y1</label>
                                <InputNumber id="promptY1" value={promptY1} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY1(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY2" className="font-bold text-xs">Y2</label>
                                <InputNumber id="promptY2" value={promptY2} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY2(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY3" className="font-bold text-xs">Y3</label>
                                <InputNumber id="promptY3" value={promptY3} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY3(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY4" className="font-bold text-xs">Y4</label>
                                <InputNumber id="promptY4" value={promptY4} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY4(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY5" className="font-bold text-xs">Y5</label>
                                <InputNumber id="promptY5" value={promptY5} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY5(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY6" className="font-bold text-xs">Y6</label>
                                <InputNumber id="promptY6" value={promptY6} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY6(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY7" className="font-bold text-xs">Y7</label>
                                <InputNumber id="promptY7" value={promptY7} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY7(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY8" className="font-bold text-xs">Y8</label>
                                <InputNumber id="promptY8" value={promptY8} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY8(e.value)} />
                            </div>
                            <div className="col-12 md:col-1">
                                <label htmlFor="promptY9" className="font-bold text-xs">Y9</label>
                                <InputNumber id="promptY9" value={promptY9} inputClassName="mt-2" disabled={style.garmentType !== 'U'} onChange={(e) => setPromptY9(e.value)} />
                            </div>
                        </div>

                        <div className="grid p-fluid">
                            <div className="col-12">
                                <DataTable value={styleImagePrompts} dataKey="imageClr_Id" size="small" loading={loadingStyleImagePrompts}
                                    scrollable scrollHeight="200px"
                                    emptyMessage="No current sequences found.">
                                    <Column field="imageClr_Id" header="Image Color Id" body={imageColorIdTemplate} align="center" alignHeader="center"></Column>
                                    <Column field="description" header="Description" body={descriptionTemplate} align="center" alignHeader="center" className="w-12rem"></Column>
                                    <Column field="imageType" header="Type" body={imageTypeTemplate} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_SetupPrompt" header="Setup Prompt" body={imageSetupPromptTemplate} align="center" alignHeader="center" ></Column>
                                    <Column field="imageClr_StrPrompt" header="Stripe Setup Prompt" body={stripeSetupPromptTemplate} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Seq" header="Sequence" body={sequenceTemplate} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X1" header="X1" body={x1Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y1" header="Y1" body={y1Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X2" header="X2" body={x2Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y2" header="Y2" body={y2Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X3" header="X3" body={x3Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y3" header="Y3" body={y3Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X4" header="X4" body={x4Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y4" header="Y4" body={y4Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X5" header="X5" body={x5Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y5" header="Y5" body={y5Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X6" header="X6" body={x6Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y6" header="Y6" body={y6Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X7" header="X7" body={x7Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y7" header="Y7" body={y7Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X8" header="X8" body={x8Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y8" header="Y8" body={y8Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_X9" header="X9" body={x9Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Y9" header="Y9" body={y9Template} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_Reverse" header="Reverse Stripe" body={reverseStripeTemplate} align="center" alignHeader="center"></Column>
                                    <Column field="imageClr_RevPrompt" header="Reverse Prompt" body={reversePromptTemplate} align="center" alignHeader="center"></Column>
                                    <Column body={editImageSetupPromptTemplate} align="center" alignHeader="center"></Column>
                                    <Column body={deleteImageSetupPromptTemplate} align="center" alignHeader="center"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </Card>
                </div>

                <Dialog visible={deleteAllOptionsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteAllOptionsDialogFooter} onHide={hideDeleteAllOptionsDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {styleImagePrompts && <span>Are you sure you want to delete all the Color Setup Options?</span>}
                        </div>
                </Dialog>

                <Dialog visible={deletePromptDialog} style={{ width: '450px' }} header="Confirm" modal footer={deletePromptDialogFooter} onHide={hideDeletePromptDialog}>
                    <div className="flex align-items-center justify-content-center">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                        {styleImagePrompt && <span>Are you sure you want to delete Image Color Id <b>{styleImagePrompt.imageClr_Id}</b>?</span>}
                    </div>
                </Dialog>
            </div>
        </div>
    );                
};

export default StyleDrawing;